var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hide)?_c('v-chip',_vm._b({attrs:{"color":_vm.color}},'v-chip',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.text)+" "+_vm._s(_vm.quota)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }